const configureSnowplow = () => {
  const cookieDomain = `.${window.location.hostname
    .replace(/www./g, '')
    .replace(/booking/g, '')}`;

  window['snowplow']('newTracker', 'itly', 'rtcollector.goeuro.com', {
    appId: 'omio',
    platform: 'web',
    encodeBase64: true,
    post: true,
    cookieDomain,
    contexts: {
      performanceTiming: true,
      webPage: true,
    },
  });
};

export default configureSnowplow;
